import { useIntl } from "react-intl";

import { ConfirmDrawer } from "@/components/ConfirmDrawer/ConfirmDrawer";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function TravellerCloseConfirmDrawer({
  open,
  onClose,
  onConfirm,
}: Props) {
  const intl = useIntl();

  return (
    <ConfirmDrawer
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={intl.formatMessage({
        defaultMessage: "Are you sure you want to leave?",
        description: "travellers.closeConfirmation.title",
      })}
      description={intl.formatMessage({
        defaultMessage: "Any unsaved data will be lost",
        description: "travellers.closeConfirmation.description",
      })}
      closeLabel={intl.formatMessage({
        defaultMessage: "Back",
        description: "back",
      })}
      confirmLabel={intl.formatMessage({
        defaultMessage: "Leave without saving",
        description: "travellers.closeConfirmation.leave",
      })}
    />
  );
}
